/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import MuiHidden from '@material-ui/core/Hidden';
import {error} from '@ion/core/src/logger/logger';

interface HiddenProps {
  hide?: 'mobile' | 'desktop' | '';
  show?: 'mobile' | 'desktop' | '';
  children: any;
}

const mobileBreakpoints = ['xs', 'sm'];
const desktopBreakpoints = ['md', 'lg', 'xl'];

const propMap = {
  show : {
    mobile  : desktopBreakpoints,
    desktop : mobileBreakpoints
  },
  hide : {
    mobile  : mobileBreakpoints,
    desktop : desktopBreakpoints
  }
};

/**
 * Defines the Hidden component that allows simple boolean props
 * to hide components based on the theme's breakpoints.
 *
 * ```typescript
 *
 *  import {Hidden} from '@ion/dls/src/layout/Hidden';
 *
 *  <Hidden hide='mobile'>
 *    <SomeComponent />
 *  </Hidden>
 *
 *  // or ...
 *
 *  <Hidden show='desktop'> // hides mobile
 *    <SomeComponent />
 *  </Hidden>
 *
 * ```
 */
export const Hidden = ({
  hide = '',
  show = '',
  children,
  ...props
}: HiddenProps) => {
  if (hide && show) error('Error - Hidden component cannot show and hide the same component');
  return (
    <MuiHidden only={hide ? propMap?.hide[hide] : propMap?.show[show]} {...props}>
      <>{children}</>
    </MuiHidden>
  );
};

export default Hidden;
